import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import styled from "styled-components";
import { FlexColumnDiv } from "./common.styles";
import { fontWeights } from "healthex-common/weights";
export const ListContainer = styled(FlexColumnDiv) `
    align-items: flex-start;
    align-self: stretch;
    padding: 0;
    gap: 16px;
`;
export const ClearRequirements = styled(FlexColumnDiv) `
    padding: 12px;
    border-radius: 12px;
    background-color: ${colors.blue_5};
    justify-content: center;
    align-items: flex-start;

    font-size: ${fontSizes.LITTLE};
`;
export const ListAndRequirements = styled(FlexColumnDiv) `
    align-items: flex-start;
    align-self: stretch;
    gap: 16px;
`;
export const FindRecordOptions = styled(FlexColumnDiv) `
    align-self: stretch;
    gap: 24px;
`;
export const FindRecordOption = styled(FlexColumnDiv) `
    padding: 20px;
    gap: 12px;
    border-radius: 40px;
    border: 1px solid ${colors.blue_10};
    align-items: center;
`;
export const FindRecordOptionIcon = styled(FlexColumnDiv) `
    height: 48px;
    width: 48px;
    border-radius: 50%;
    background-color: ${colors.blue_10};
    justify-content: center;
    align-items: center;
    flex-shrink: 0;

    svg {
        width: 27px;
        height: 27px;
    }
`;
export const FindRecordOptionTitle = styled(FlexColumnDiv) `
    color: ${colors.black_light};
    font-weight: ${fontWeights.SEMI_BOLD};
    align-self: center;
`;
export const FindRecordOptionText = styled(FlexColumnDiv) `
    color: ${colors.navy_main};
    font-size: ${fontSizes.LITTLE};
    align-self: center;
`;
